import { render, staticRenderFns } from "./LinksTecVisitsAdmin.vue?vue&type=template&id=ff36cd6c"
import script from "./LinksTecVisitsAdmin.vue?vue&type=script&lang=js"
export * from "./LinksTecVisitsAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports